export default __webpack_public_path__ + "static/media/hand-bg-icon.cd81b958.svg";